import React, { useEffect, useRef } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { constants } from '../../../../config';

mapboxgl.accessToken = constants.REACT_APP_MAPBOX;

const WorkLocationMap = ({ latitude, longitude, zoom = 12, workCode, establishmentName }) => {
	const mapContainer = useRef(null);
	const mapRef = useRef(null);

	useEffect(() => {
		if (!mapContainer.current) return;

		// Inicializar mapa
		const map = new mapboxgl.Map({
			container: mapContainer.current,
			style: 'mapbox://styles/mapbox/satellite-streets-v11',
			center: [longitude, latitude], // [lng, lat] - Mapbox usa este orden
			zoom: zoom,
		});

		mapRef.current = map;

		// Agregar controles de navegación
		map.addControl(new mapboxgl.NavigationControl(), 'top-right');

		// Esperar a que el mapa cargue completamente
		map.on('load', () => {
			// Agregar fuente de datos para el círculo
			map.addSource('work-location', {
				type: 'geojson',
				data: {
					type: 'Feature',
					geometry: {
						type: 'Point',
						coordinates: [longitude, latitude]
					},
					properties: {
						workCode: workCode || 'Sin código',
						establishmentName: establishmentName || 'Sin nombre'
					}
				}
			});

			// Agregar capa de círculo
			map.addLayer({
				id: 'work-circle',
				type: 'circle',
				source: 'work-location',
				paint: {
					'circle-radius': 8,
					'circle-color': '#ffffff',
					'circle-stroke-width': 3,
					'circle-stroke-color': '#9ca4ae',
					'circle-opacity': 0.8
				}
			});

			// Agregar popup al hacer clic en el círculo
			map.on('click', 'work-circle', (e) => {
				const coordinates = e.features[0].geometry.coordinates.slice();
				const workCode = e.features[0].properties.workCode;
				const establishmentName = e.features[0].properties.establishmentName;

				// Crear popup
				new mapboxgl.Popup()
					.setLngLat(coordinates)
					.setHTML(`
						<div style="padding: 8px;">
							<p style="margin: 0; font-size: 14px; font-weight: 500;">
								${establishmentName} - ${workCode}
							</p>
						</div>
					`)
					.addTo(map);
			});

			// Cambiar cursor al pasar sobre el círculo
			map.on('mouseenter', 'work-circle', () => {
				map.getCanvas().style.cursor = 'pointer';
			});

			map.on('mouseleave', 'work-circle', () => {
				map.getCanvas().style.cursor = '';
			});
		});

		// Cleanup: remover mapa cuando el componente se desmonte
		return () => {
			if (mapRef.current) {
				mapRef.current.remove();
			}
		};
	}, [latitude, longitude, zoom, workCode]);

	return (
		<div 
			ref={mapContainer} 
			style={{ 
				width: '100%', 
				height: '100%',
				minHeight: '400px',
				borderRadius: '4px'
			}} 
		/>
	);
};

export default WorkLocationMap;
